import classNames from 'classnames';
import React from 'react';

import {Button, Picture} from '@udemy/react-core-components';
import {tokens} from '@udemy/styles';

import {BannerData} from 'src/features/lohp/hooks/useFetchHeroBanners';

import styles from './consolidated-hero-banner.module.less';

const HERO_BANNER_TARGETS = {
    self: '_self',
    new_tab: '_blank',
} as const;

export interface ConsolidatedHeroBannerSlideProps {
    data: BannerData;
    backgroundColor?: string;
    shapeColor?: string;
    isActive: boolean;
    onCtaClick?: () => void;
}

export const ConsolidatedHeroBannerSlide = ({
    data,
    backgroundColor,
    shapeColor,
    isActive,
    onCtaClick,
}: ConsolidatedHeroBannerSlideProps) => {
    const target = HERO_BANNER_TARGETS[data.cta_1_target ?? 'self'];

    const pictureSources = [
        {
            srcSet: data.image,
            media: `(min-width: ${tokens['breakpoint-md-min']})`,
        },
    ];

    return (
        <div
            className={classNames(styles.slide, {
                [styles['slide--inactive']]: !isActive,
            })}
            style={{backgroundColor}}
            aria-hidden={!isActive}
        >
            <div
                className={styles['slide-shape']}
                aria-hidden="true"
                style={{'--shape-color': shapeColor} as React.CSSProperties}
            />
            <div
                className={classNames(styles['slide-content'], {
                    [styles['slide-content--dark']]: data.layout === 'wide-dark',
                })}
            >
                <h2
                    className={classNames('ud-heading-xl', styles.title)}
                    dangerouslySetInnerHTML={{__html: data.title}}
                />
                <p
                    className={classNames('ud-text-md', styles.subtitle)}
                    dangerouslySetInnerHTML={{__html: data.subtitle}}
                />
                {data.cta_1_url && data.cta_1_text && (
                    <Button
                        componentClass="a"
                        href={data.cta_1_url}
                        target={target}
                        onClick={onCtaClick}
                        tabIndex={isActive ? 0 : -1}
                        udStyle="primary"
                        size="small"
                        className={styles.cta}
                    >
                        {data.cta_1_text}
                    </Button>
                )}
            </div>
            <Picture
                className={styles['slide-image']}
                imgClassName={styles['slide-image-img']}
                sources={pictureSources}
                src={data.image_responsive}
                alt=""
            />
        </div>
    );
};
